import { type Brand } from '@growtherapy/tailwind/react';

import { setAlertTitle, setDefaultFavicon, setTitle } from '../../metadata';

export function setFaviconAndTitleBasedOnUnreadMessagesCount(
  unreadMessagesCount: number,
  defaultTitle: string,
  brand?: Brand,
) {
  if (unreadMessagesCount) {
    const unreadMessagesTitle = `(${unreadMessagesCount}) message${unreadMessagesCount > 1 ? 's' : ''}`;
    setAlertTitle(unreadMessagesTitle, brand);
    return;
  }
  setDefaultFavicon(brand);
  setTitle(defaultTitle);
}
